var map = {
	"./custom/app/header/header.component": [
		"tppE",
		56
	],
	"./dspace/app/header/header.component": [
		"acxG",
		85
	],
	"./rd_senado/app/header/header.component": [
		"GKx+",
		101
	],
	"./rd_senado_cms/app/header/header.component": [
		"iQm+",
		143
	],
	"./rd_senado_faq/app/header/header.component": [
		"b0s8",
		186
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "M7g8";
module.exports = webpackAsyncContext;